import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";

import Paper from "@mui/material/Paper";
import { FunctionalModalStyle } from "../../../../../../common/constants/custom-style";
import { CustomerDatabaseStore } from "../../../../../../store/main/CustomerDatabaseStore";
import { useEffect } from "react";

interface Props {
  open: boolean;
  handleClose: Function;
  title: string;
  teamName: string;
}
const FailedTransferModal: React.FC<Props> = ({
  open,
  handleClose,
  title,
  teamName,
}) => {
  const { raiseTicket, failedDeactivates, userDetails } =
    CustomerDatabaseStore();

  useEffect(() => {
    if (failedDeactivates.length == 0) {
      setTimeout(() => {
        handleClose();
      }, 3000);
    }
  }, []);

  const jsonString = JSON.stringify(failedDeactivates);
  const cleanString = jsonString.replace(/\\/g, "");

  return (
    <>
      <Modal open={open} onClose={() => handleClose()}>
        <Box sx={FunctionalModalStyle}>
          {failedDeactivates.length == 0 ? (
            <>
              <Typography
                variant="h3"
                marginBottom={2}
                textAlign={"center"}
                color={"primary"}
              >
                Successful
              </Typography>
              <Typography variant="h5" marginBottom={2} textAlign={"center"}>
                {`All Customers ${title} Succesfully`}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h5" marginBottom={2} textAlign={"center"}>
                {`Failed ${title}`}
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Customer ID</TableCell>
                      <TableCell>Reason for Failure</TableCell>
                    </TableRow>
                  </TableHead>
                  {failedDeactivates.length > 0 ? (
                    <TableBody>
                      {failedDeactivates.map((data) => {
                        return (
                          <>
                            <TableRow>
                              <TableCell>{data.id}</TableCell>
                              <TableCell>{data.reason}</TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <Typography variant="subtitle1">
                      No Failure Occured
                    </Typography>
                  )}
                </Table>
              </TableContainer>
              <Stack
                alignItems={"center"}
                direction={"column"}
                justifyContent={"center"}
                marginX={"auto"}
                marginTop={1}
                gap={4}
              >
                <Typography
                  color={"error.main"}
                  variant="subtitle2"
                  textAlign={"center"}
                >
                  Please raise a support ticket
                  <Typography
                    color={"primary"}
                    variant="subtitle2"
                    textAlign={"center"}
                    sx={{
                      marginTop: "5px",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => {
                        raiseTicket({
                          description: cleanString,
                          subject: `Regarding failed Customer ${title}`,
                          email: userDetails.official_email,
                          type: "customer_sync_issue",
                          priority: 1,
                          status: 2,
                          cc_emails: ["rahul.tambat@goapptiv.com"],
                          custom_fields: {
                            cf_assigned_to: "Rahul",
                            cf_category_issues: "customer_sync",
                            cf_bu: teamName,
                          },
                        });
                        handleClose();
                      }}
                    >
                      Click to Raise Ticket
                    </Button>
                  </Typography>
                </Typography>
              </Stack>
            </>
          )}
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            marginX={"auto"}
          >
            <Button
              variant="text"
              color="error"
              onClick={() => {
                handleClose();
              }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default FailedTransferModal;
